import React, {Component} from "react";

class ResultClassInfo extends Component {
    render() {
        const {class_info} = this.props;

        return (
            <div className="class-info" style={{display: "flex", placeItems: "center", marginBottom: "50px"}}>
                <div style={{display: "flex", flexDirection: "row", width: "100%", textTransform: "uppercase"}}>
                    <div className="print-identity-card">
                        <div className="wrapper">
                            <h4>{"پوهنتون آریا"}</h4>
                            <h4>{"ARIA UNIVERSITY"}</h4>
                        </div>
                    </div>
                    <div className="print-identity-card">
                        <div className="wrapper">
                            <h4>{class_info?.faculty}</h4>
                            <h4>Faculty Of {class_info?.faculty_en}</h4>
                        </div>
                    </div>

                    {/* Show the department only if it is not null */}
                    {class_info?.department ? <div className="print-identity-card">
                        <div className="wrapper">
                            <h4> ({class_info?.department}) {"دپارتمنت"}</h4>
                            <h4> {"DEPARTMENT"} ({class_info?.department_en}) </h4>
                        </div>
                    </div> : ''}


                    <div className="print-identity-card">
                        <div className="wrapper">
                            <h4> {"جدول نتایج"} {class_info?.class_desc}</h4>
                            <h4>{class_info?.faculty} ({class_info?.entry_year})  {class_info?.time}</h4>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ResultClassInfo;
